import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Input, Btn } from "@/components/UI";
import { fmtQty } from "@/lib/products";
import { apiError } from "@/lib/customers";

// Fiziksel sayım sonrası gerçek stok (yeni değer kalıcıdır).
export function MaterialCountModal({ material, onClose, onSaved }) {
  const [value, setValue] = useState("");
  const [desc, setDesc] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => { if (material) { setValue(String(material.stock_qty)); setDesc(""); setErr(""); } }, [material]);
  if (!material) return null;
  const save = async () => {
    if (value === "" || Number.isNaN(Number(value))) return setErr("Geçerli bir miktar girin");
    try { onSaved(await api.post(`/product-materials/${material.id}/count`, { value: Number(value), description: desc })); }
    catch (e) { setErr(apiError(e, "Kaydedilemedi")); }
  };
  return (
    <Modal open onClose={onClose} title={`Stok Sayımı — ${material.name}`}>
      <div className="space-y-3" data-testid="material-count-modal">
        <div className="text-sm text-slate-600">Sistemdeki stok: <b data-testid="material-count-current">{fmtQty(material.stock_qty)}</b></div>
        <Input label="Fiziksel Sayım (yeni stok)" type="number" step="any" value={value} onChange={(e) => setValue(e.target.value)} data-testid="material-count-value" />
        <Input label="Açıklama" value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="material-count-desc" />
        {err && <div className="text-xs text-rose-600" data-testid="material-count-error">{err}</div>}
        <div className="flex justify-end gap-2">
          <Btn variant="secondary" onClick={onClose} data-testid="material-count-cancel">Vazgeç</Btn>
          <Btn onClick={save} data-testid="material-count-save">Kaydet</Btn>
        </div>
      </div>
    </Modal>
  );
}
